import React, {useEffect} from "react";
import {AmchartSeeker} from "@ui-seeker/core";
import {useToast} from "../../../../@hooks";
import {AppModal} from "../../../../@components";
import {reports, searchID} from "@signals";
import AnalyzerExecutionInfo, { hasExecutionInfo } from "../ExecutionInfo";
import { mainSeriesLook } from "./mainSeriesLook";


export default function FullScreenChartModal({ titleChart, officeData, executionDateTime, filteredChart, seriesToApply, showByPrice, isOpen, toggleOpen, isDateAxis, xTitle, isRating, ...props }) {

    const { showToast } = useToast();

    useEffect(() => {
        if(isOpen) showToast.info("Press ESC to exit fullscreen mode")
    },[isOpen]);

    return <AppModal
        isOpen={isOpen}
        controller={() => toggleOpen()}
        title={titleChart}
        icon="chart-line"
        subtitle={!searchID.value && !!reports.value && hasExecutionInfo(officeData, executionDateTime) && <AnalyzerExecutionInfo officeData={officeData} executionDateTime={executionDateTime} fontSize={13}/>}
        containerProps={{ fullScreen: true, sx: {
            '.MuiDialogContent-root': { px: 3, pt: 0, pb: 2 },
            '.MuiDialogContent-root .MuiCard-root': { border: 'none', boxShadow: 'none', borderRadius: 0 },
        }}}
        hideActions>
        <AmchartSeeker
            rootID="ChartSelectedFullscreen"
            data={filteredChart}
            series={seriesToApply.map(({ dataKey, color, isMain }) => ({
                name: dataKey,
                yField: dataKey,
                xField: 'date',
                color: color,
                connect: true,
                type: (titleChart !== 'Dates of Rental' && titleChart !== "Length of Rental") ? 'column' : 'line',
                tooltip: {
                    pointerOrientation: "horizontal",
                },
                tension: 1,
                ...mainSeriesLook(isMain),
            }))}
            sx={{ height: 'calc(100vh - 190px)' }}
            chartProps={{
                showBullets: true,
                enabledPDF: false,
                numberFormat: `#,###.00 ' ${showByPrice !== "price" ? '%' : ""}'`,
                dateFormatReceived: 'yyyyMMdd',
                scrollbarY: {
                    show: true
                },
                xAxis: {
                    categoryField: 'date',
                    maxDeviation: 0.3,
                    isDateAxis: isDateAxis,
                    dateFormat: 'dd MMM yyyy (EEE)',
                    title: xTitle,
                    baseInterval: {
                        timeUnit: 'day',
                        count: 1
                    },
                    labelProps: {
                        rotation: filteredChart.some(({ date }) => date.length > 8) ? "10" : "0"
                    },
                    ...props.labelProps
                },
                yAxis: {
                    title: isRating ? 'Rating' : showByPrice === "price" ? 'Prices' : "Variation"
                },
            }}
        />
    </AppModal>
}